<template>
    <section>
        <o-field label="Title">
            <o-input v-model="title"></o-input>
        </o-field>

        <o-field label="Subtitle">
            <o-input class="mt-2" v-model="subtitle"></o-input>
        </o-field>

        <o-field label="Author">
            <o-input class="mt-2" v-model="author"></o-input>
        </o-field>

        <o-field label="Excerpt">
            <o-input class="mt-2" v-model="excerpt"></o-input>
        </o-field>

        <o-field label="Category">
            <o-input class="mt-2" v-model="category"></o-input>
        </o-field>

        <o-field label="Primary Image">
            <div v-if="primaryImageSelected" class="mt-2">
                <button disabled class="button is-primary mr-2 slightly-rounded">Image Selected<i class="fa-solid fa-check ml-3 is-success"></i></button>
                <button @click="chooseImage" class="button is-light mx-2 slightly-rounded">Click to change image</button>
                <br>
                <div class="mt-3">{{ imageUrl }}</div>
            </div>
            <button v-else @click="chooseImage" class="button is-light mt-2 slightly-rounded">Select Primary Image</button>
        </o-field>

        <o-field v-if="primaryImageSelected" label="Primary Image Caption">
            <o-input v-model="caption"></o-input>
        </o-field>

        <o-field class="pb-5" label="Select a Date">
            <br>
            <div class="control mt-2">
                <input
                    class="input"
                    type="date"
                    v-model="date" >
            </div>
        </o-field>
    </section>
</template>
<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
    data() {
        return {
            title: '',
            subtitle: '',
            author: '',
            excerpt: '',
            category: '',
            caption: '',
            date: ref(new Date().toISOString().substr(0, 10)),
        }
    },
    emits: ['mdFields', 'chooseImage'],
    props: ['primaryImageSelected', 'imageUrl', 'updateFields'],
    methods: {
        emitFields() {
            this.$emit('mdFields', { mdFields: this.fields })
        },
        chooseImage() {
            this.$emit('chooseImage')
        }
    },
    mounted() {
        this.emitFields()
    },
    computed: {
        fields() {
            if (this.caption) {
                return {
                    title: this.title,
                    subtitle: this.subtitle,
                    author: this.author,
                    excerpt: this.excerpt,
                    category: this.category,
                    caption: this.caption,
                    date: this.date,
                }
            } else {
                return {
                    title: this.title,
                    subtitle: this.subtitle,
                    author: this.author,
                    excerpt: this.excerpt,
                    category: this.category,
                    date: this.date,
                }
            }
        }
    },
    watch: {
        title: function(newValue, oldValue) { this.emitFields() },
        subtitle: function (newValue, oldValue) { this.emitFields() },
        author: function(newValue, oldValue) { this.emitFields() },
        excerpt: function (newValue, oldValue) { this.emitFields() },
        category: function (newValue, oldValue) { this.emitFields() },
        date: function (newValue, oldValue) { this.emitFields() },
        caption: function (newValue, oldValue) { this.emitFields() },

        updateFields: function (newUpdateFields) {
            // Update data properties based on the contents of updateFields
            this.title = newUpdateFields.title || ''
            this.subtitle = newUpdateFields.subtitle || ''
            this.author = newUpdateFields.author || ''
            this.excerpt = newUpdateFields.excerpt || ''
            this.category = newUpdateFields.categories || ''
            this.caption = newUpdateFields['image-caption'] || ''
            this.date = newUpdateFields.date.substr(0, 10) || ref(new Date().toISOString().substr(0, 10))
        }
    }
})
</script>

